import { CommonModule } from '@angular/common';
import { AfterViewInit, Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

// Components
import { ButtonComponent } from '../../../../../../shared/_components/button/button.component';
import { CheckboxComponent } from '../../../../../../shared/_components/checkbox/checkbox.component';
import { TextAreaComponent } from '../../../../../../shared/_components/text-area/text-area.component';
import { FlowMediaUploadStep } from '../../flows/flow-media-upload/step/flow-media-upload-step.component';
import { PostPreviewComponent } from '../../post-preview/post-preview.component';

// Models
import { IntegrationProvider } from '../../../../../models/integration-providers.model';

@Component({
  selector: 'pp-step-integration-x',
  templateUrl: './step-integration-x.component.html',
  imports: [CommonModule, ButtonComponent, CheckboxComponent, PostPreviewComponent, TextAreaComponent],
})
export class StepIntegrationXComponent extends FlowMediaUploadStep implements AfterViewInit {

  // Component handler (!IMPORTANT - Must match step identifier for this flow)
  identifier = 'mediaUploadFlowStepIntegrationX';

  constructor() {
    super();

    this.form = new FormGroup({
      xPostTitle: new FormControl<string>(''),
      xPostDescription: new FormControl<string>('', Validators.required),
      xIncludeOddrLink: new FormControl<boolean>(true),
    });
  }

  ngAfterViewInit(): void {
    this.form.get('xPostTitle')?.setValue(this.operation?.title ?? '');
    this.form.get('xPostDescription')?.setValue('');
  }

  oddrLinkSelected(include: boolean): void {
    this.form.get('xIncludeOddrLink')?.setValue(include);
  }

  submitAndGoToNextStep(): void {
    this.mediaUploadService.storeSelectedIntegrationPayload(this.constructAndStorePayloadForProvider()).subscribe({
      next: () => this.goToNextStep(),
    });
  }

  private constructAndStorePayloadForProvider(): any {
    const payload = {
      title: this.form.get('xPostTitle')?.value as string,
      description: this.form.get('xPostDescription')?.value as string,
      includeOddrLink: this.form.get('xIncludeOddrLink')?.value as boolean,
    };
    return this.cleanIntegrationPayload(IntegrationProvider.X, payload);
  }
}
